// Copyright (c) 2016 Deere & Company

import DealerSearchParams, {getDefaultState} from '../state/dealer-search-params';
import actions from '../../actions-list';

const updateDealerSearchParams = (state, action) =>
    DealerSearchParams.update(state, {
        [action.name]: {
            $set: action.value
        }
    });

const updateDealerSearchDivisionParam = (state, action) =>
    DealerSearchParams.update(state, {
        division: {
            $set: action.value
        }
    });

const resetDealerSearchParams = state =>
    DealerSearchParams.update(state, {
        $set: getDefaultState()
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_DEALER_SEARCH_PARAMS]: resetDealerSearchParams,
        [actions.UPDATE_DEALER_SEARCH_PARAMS]: updateDealerSearchParams,
        [actions.UPDATE_DEALER_SEARCH_DIVISION_PARAMS]: updateDealerSearchDivisionParam
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/dealer-search/reducers/dealer-search-params.js